import axios from "axios";
import { toast } from "react-toastify";
const BASE_URL = process.env.REACT_APP_URL;

//  get industry
export const GET_DASHBOARD_REQUEST = "GET_DASHBOARD_REQUEST";
export const GET_DASHBOARD_SUCCESS = "GET_DASHBOARD_SUCCESS";
export const GET_DASHBOARD_FAILURE = "GET_DASHBOARD_FAILURE";

export const getDashboardData = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_DASHBOARD_REQUEST });
      const URL = `${BASE_URL}/dashboard/data/v1`;
      const res = await axios.get(URL, {
        headers: {
          Authorization: localStorage.getItem("token"),
        }
      });
      dispatch({ type: GET_DASHBOARD_SUCCESS, payload: res?.data });
    } catch (error) {
      dispatch({ type: GET_DASHBOARD_FAILURE, payload: error.message });
    }
  };
};